module.exports = __webpack_public_path__ + "static/media/crocodile(29).e2477aad.PNG";